import { Env } from '../environments/environment';

export interface IKampyleOnsiteSdkGlobal {
  readonly updatePageView: () => void;
}

export interface IMedalliaCustomParams {
  jobName?: string;
  uid?: string;
  countryCode?: string;
  languageCode?: string;
  env?: Env;
  storeId?: string;
}

declare global {
  interface Window {
    amplitude: typeof import('@amplitude/analytics-browser');
    medalliaCustomParams?: IMedalliaCustomParams;
    readonly KAMPYLE_ONSITE_SDK?: IKampyleOnsiteSdkGlobal;
  }
}

export class Medallia {
  public static setCustomParams(
    customParams: Required<IMedalliaCustomParams>,
  ): void {
    if (!window.medalliaCustomParams) {
      window.medalliaCustomParams = {};
    }

    window.medalliaCustomParams.jobName = customParams.jobName;
    window.medalliaCustomParams.uid = customParams.uid;
    window.medalliaCustomParams.countryCode = customParams.countryCode;
    window.medalliaCustomParams.languageCode = customParams.languageCode;
    window.medalliaCustomParams.env = customParams.env;
    window.medalliaCustomParams.storeId = customParams.storeId;

    Medallia._updatePageView();
  }

  private static _updatePageView(): void {
    if (window.KAMPYLE_ONSITE_SDK) {
      window.KAMPYLE_ONSITE_SDK.updatePageView();
    }
  }
}
